export default __webpack_public_path__ + "static/meet-with-zupr-4bc3bbbc26e2327243ea50008e77caf7.png";